import { render, staticRenderFns } from "./DashboardCookingHealthListIndex.vue?vue&type=template&id=74b88989&"
import script from "./DashboardCookingHealthListIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardCookingHealthListIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports